import dayjs  from "dayjs";
import { PDFDocument } from "pdf-lib"; // npm install pdf-lib

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  })
}

export default {

// 下载pdf
  ExcelDownload(name, file) {
    // console.log(name, file);
    let blob = new Blob([file],
      { type: "application/vnd.ms-excel" });
    // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
    let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
    // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
    let a = document.createElement("a");
    a.href = url;
    //
    // a.download = "'原始销售-' + . 'xls'";
    a.download = `${name}-${dayjs().format('YYYY-MM-DD')}.xlsx`
    a.click();
    // 5.释放这个临时的对象url
    window.URL.revokeObjectURL(url);
  },
  PDFDownload(name, file, addDate = true) {
    const base64String = file; // Base64 编码的文件内容
    // 将 Base64 编码转换为 Blob 对象
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // 创建临时链接并下载文件
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const dateSuffix = addDate ? `-${dayjs().format("YYYY-MM-DD")}` : "";
    a.href = url;
    a.download = `${name}${dateSuffix}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  async PDFDownloadMerge(name, files, addDate = true) {
    try {
      const fileList = Array.isArray(files) ? files : [files];

      if (fileList.length > 1) {
        // 多个 PDF → 合成
        const mergedPdf = await PDFDocument.create();

        for (const file of fileList) {
          if (!file || typeof file !== "string") continue;

          const cleanedBase64 = file.replace(/\s/g, "");
          const byteString = atob(cleanedBase64);
          const byteArray = new Uint8Array(byteString.length);
          for (let i = 0; i < byteString.length; i++) {
            byteArray[i] = byteString.charCodeAt(i);
          }

          const pdf = await PDFDocument.load(byteArray);
          const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          copiedPages.forEach((page) => mergedPdf.addPage(page));
        }

        const mergedBytes = await mergedPdf.save();
        const finalBlob = new Blob([mergedBytes], { type: "application/pdf" });

        this.downloadBlob(finalBlob, name, addDate);
      } else {
        // 单个 PDF → 直接下载
        const singleFile = fileList[0];
        const cleanedBase64 = singleFile.replace(/\s/g, "");
        const byteString = atob(cleanedBase64);
        const byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: "application/pdf" });
        this.downloadBlob(blob, name, addDate);
      }
    } catch (error) {
      console.error("PDF 合并下载失败:", error);
    }
  },

  downloadBlob(blob, name, addDate) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const dateSuffix = addDate ? `-${dayjs().format("YYYY-MM-DD")}` : "";
    a.href = url;
    a.download = `${name}${dateSuffix}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

};